import React from 'react';
import './About.css';
import Image from '../../assets/mypic/about.jpg';
import AboutBox from './AboutBox';// keep old resume for preview

const About = () => {

    const downloadResume = () => {
        // Google Drive direct download link
        const url = "https://drive.google.com/file/d/1EE4DDNMU3qT_fbaLVnV2r3mSA-a0evae/view?usp=sharing";
        window.open(url, '_blank');
    }


    return (
        <section className="about container section" id="about">
            <h2 className="section__title">About Me</h2>

            <div className="about__container grid">
                <img src={Image} alt="Profile" className="about__img" />

                <div className="about__data grid">
                    <div className="about__info">
                        <p className="about__description">
                            Hello! I’m Atikur Rahman, a fresh Computer Science graduate from BRAC University, Bangladesh. 
                            My academic journey culminated in a thesis on infrastructure detection using drone imagery 
                            and machine learning. Along the way, I participated 
                            actively in university clubs like BUEDF, ROBU, and BUCC.<br /><br />
                            I have a strong passion for software development, machine learning, and solving real-world 
                            problems with clean, efficient code. These days, my focus is on building impactful AI-driven 
                            applications, expanding my portfolio, and contributing to open-source projects.<br /><br />
                            Here are a few technologies I’ve been working with recently:
                        </p>
                        <ul className="about__list">
                            <li>Python</li>
                            <li>JavaScript</li>
                            <li>React</li>
                            <li>Flask</li>
                            <li>MySQL</li>
                            <li>Next.js</li>
                        </ul>

                        <div className="about__buttons">
                            <button className="btn" onClick={downloadResume}>Download Resume</button>
                        </div>
                    </div>
                </div>
            </div>

            <AboutBox />
        </section>
    )
}

export default About;
